import { Component, Input, ViewChild, EventEmitter, Output, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
// import { ColumnDef, ColumnDatatype, ExportProvider, UIService } from 'ess-plugin-ui';
import { Table } from 'primeng/table';
// import { BsModalService } from 'ngx-bootstrap';
import { I18N } from 'ess-plugin-base';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ColumnDef, ExportProvider } from '../table/export';
import { UIService } from '../ui.service';

@Component({
    selector: 'ess-datatable',
    templateUrl: './prime.table.html',
    styleUrls: ['./prime.table.scss']
})
export class PrimeTable implements OnInit, OnChanges {

  /**
   * Array of object to display.
   */
    @Input('data')
    data: any[] = [];

    editing: any = null;
  
    /**
     * Settings object to turn features on and off.
     * <pre>
     * Example:
      *    settings: {
      *        title?: string,
      *        primaryKey: string,
      *        pageSize?: number,
      *        searchOnline?: boolean,
      *        can: {
      *            search?: boolean,
      *            insert?: boolean,
      *            update?: boolean,
      *            delete?: boolean,
      *            orderRows?: boolean,
      *            orderColumns?: boolean,
      *            resizeColumns?: boolean,
      *            toggleColumns?: boolean,
      *            groupRows?: boolean,
      *            exportXls?: boolean,
      *            exportPdf?: boolean,
      *        }
      *    };
     * </pre>
     */
    @Input('settings')
    settings: {
        title?: string,
        primaryKey: string,
        pageSize?: number,
        searchOnline?: boolean,
        can: {
            search?: boolean,
            insert?: boolean,
            update?: boolean,
            delete?: boolean,
            orderRows?: boolean,
            orderColumns?: boolean,
            resizeColumns?: boolean,
            toggleColumns?: boolean,
            groupRows?: boolean,
            exportXls?: boolean,
            exportPdf?: boolean,
        }
    };

    /**
     * Triggered when a phrase is searched for. This should update the [data] array.
     */
    @Output('onSearch')
    onSearch: EventEmitter<string> = new EventEmitter<string>();

    // @Input('onInsert')
    // onInsert: EventEmitter<string> = new EventEmitter<string>();

    /**
     * Trigger when a row needs to be saved.
     */
    @Output('onSave')
    onSave: EventEmitter<any> = new EventEmitter<any>();

    /**
     * Triggered when a row needs to be deleted.
     */
    @Output('onDelete')
    onDelete: EventEmitter<any> = new EventEmitter<any>();

    /**
     * Function name to call when a new item needs to be inserted.
     * <br>
     * The function should return a suitable new item.
     */
    @Input('newItem')
    newItem: () => any;

    /**
     * Function name to call when validating a row.
     * <br>
     * The function must accept an object and return true if it passes validation tests (can be saved), otherwise false.
     */
    @Input('isValid')
    isValid: (any) => boolean;

    // @Input('contract')
    // contract: LContract;
    
    // @Input('optionValue')
    // optionValue = 'value';

    phrase: string;
    phraseChanged: Subject<string> = new Subject<string>();
    phraseWatch: Subscription;
  
    filteredData: any[] = null;

    /**
     * Definition of colums to display.
     */
    @Input('cols')
    cols: ColumnDef[] = []

    selectedColumns: ColumnDef[] = [];

    /**
     * Names of fields to keep visible even when the table is scrolled.
     */
    @Input('frozenCols')
    frozenCols = []  

    /**
     * Array of column definitions to group by.
     * <br>
     * Grouping is performed for values in each column (in order).
     */
    @Input('group')
    groupCols: ColumnDef[];

    pageSize: number = 10;
    changed: any[] = null;  // created lazily
    cloned: { [id: number]: any } = {};
  
    // @ViewChild('editDialog', {static: true})
    // editDialog: ElementRef;
  
    @ViewChild('dt', {static: true})
    dt: Table;
  
    constructor(    //private dataProvider: DataProvider, private router: Router,
      private exporter: ExportProvider, private ui: UIService,
      private i18n: I18N /*, private modalService: BsModalService*/ ) { }
  
    async ngOnInit() {
        this.pageSize = this.settings.pageSize || this.pageSize;
    //   await this.dataProvider.initCache();
  
    //   let pattern: any = {};
    //   if (this.contract) {
    //     pattern.contract = this.contract.code || this.contract;
    //   }
  
    //   this.dataProvider.getMatching<LServer>(new LServer(pattern))
    //   .then(input => {
    //       this.data = input;
  
    //       this.data.map(item => item['__id'] = item.id);
    //   });

    this.selectedColumns = this.cols.filter(col => !col.hidden);
  
      this.data.map(item => item['__id'] = item[this.settings.primaryKey || 'id'] );

      this.phraseWatch = this.phraseChanged
              .pipe(debounceTime(600), // wait 300ms after the last event before emitting last event
              distinctUntilChanged()) // only emit if value is different from previous value
              .subscribe(phrase => this.search());

      this.updateGroupMap(this.groupCols);
    }

    ngOnChanges(changes: SimpleChanges) {
      if (changes && changes.cols) {
          this.selectedColumns = this.cols;
      }

      this.updateGroupMap(this.groupCols);
    }
  
    ngOnDestroy() {
      if (this.phraseWatch) {
        this.phraseWatch.unsubscribe();
      }
    }
  
    search() {
        this.onSearch.emit(this.phrase);

    //   let pattern = new LServer(null);
    //   if (this.contract) {
    //     pattern.contract = this.contract.code;
    //   }
      //pattern['name'] = this.phrase;
  
    //   this.dataProvider.getMatching<LServer>(pattern)
    //   .then(input => {
    //       this.data = input;
    //   });
    }
  
    changePhrase() {
      this.phraseChanged.next(this.phrase);
    }

    // selectEnum(field: string, event: any) {
    //   if (this.optionValue) {
    //     this.editing[field] = event[this.optionValue];
    //   }
    // }
  
    open(item: any){
      // this.router.navigate(['license/server', item.code]);
    }
  
    add(){
        if (this.newItem)
        this.editing = this.newItem();

    //   let pattern: LServer = {};
    //   if (this.contract) {
    //     pattern.contract = this.contract.code || this.contract;
    //   }
  
    //   this.editing = new LServer(pattern);
      // this.modalService.show(this.editDialog);
    }
  
    addSaved() {
    //   this.data.push(new LServer(this.editing));
      // this.hideDialog();
      this.editing = null;
    }
  
    addCancelled(){
      // this.hideDialog();
      this.editing = null;
    }
  
    hideDialog() {
    //   this.modalService.hide(1);
    }
  
    trackById = (index, item) => {
        const pk = item[this.settings.primaryKey || 'id'];
        return pk;
    }


    autoSorting: boolean;

    groupMap:any = {};

    onSort() {
      if (!this.autoSorting) {
        this.updateGroupMap(this.groupCols);
        // this.updateGroupIndices(this.groupCols);
      }
    }

    onFilter(event: any) {
      if (!this.autoSorting) {
        this.filteredData = event.filteredValue;
        this.updateGroupMap(this.groupCols);
        // this.updateGroupIndices(this.groupCols);
      }
    }

    updateGroupMap(col: ColumnDef[]) {
      this.groupMap = {};

      let shown = this.filteredData || this.data;

      // Match the group field to one of the existing columns..
      if (col && col.length && this.cols) {
          let matched: ColumnDef[] = [];
          for(let grp of col) {
              for(let one of this.cols) {
                if (one.field.toLowerCase() == grp.field.toLowerCase()) {
                  matched.push(one);
                }
              }
          }
          this.groupCols = matched;
          col = matched;
      }
      
      if (shown && col && col.length) {

        this.autoSorting = true;
        // this.dt.sortColumn = this.dt.columns.find(col => col.field === col.field);
        this.dt._multiSortMeta = [];
        for(let sort of col) {
          this.dt._multiSortMeta.push({field: sort.field, order: 1})
        }
        this.dt.sortMultiple();
        // this.dt.sortField = col[0].field;  //paginationOptions.SortColumn;
        // this.dt.sortSingle();

        setTimeout(() => {
            this.autoSorting = null;
            let last: any = {};

            for (let i = 0; i < shown.length; i++) {
                let heads: string[] = [];

                for (let c = 0; c < col.length; c++) {
                    let rowData = shown[i];
                    let key = col[c].field;
                    let value = rowData[key];
                
                    if (i == 0) {
                        heads.push( value);
                    }
                    else {
                        // let previousRowData = this.data[i - 1];
                        // last[key] = previousRowData[key];
                        if (value != last[key]) {
                            heads.push(value);
                        }
                    }
                    last[key] = value;
                }
                if (heads.length) {
                    this.groupMap['' + i] = [];
                    for (let c = 0; c < col.length; c++) {
                      this.groupMap['' + i].push( last[col[c].field] );
                    }
                    // this.groupMap['' + i] = heads;
                    // last = {};
                }
          }
          this.groupMap = Object.assign({}, this.groupMap);

        }, 300)
      }
    }

    // @Input() 
    // get selectedColumns(): any[] {
    //   return this._selectedColumns;
    // }

    // set selectedColumns(val: any[]) {
    //   //restore original order
    //   this._selectedColumns = this.cols.filter(col => val.includes(col));
    // }    
  
    added: number = 0;
  
    addRow() {
        if (this.newItem)
        this.editing = this.newItem();

        if (this.editing) {
            this.added -= 1;
            this.editing['__id'] = this.added;

            this.data.splice(0, 0, this.editing);
            this.dt.initRowEdit(this.editing);
        }
    //   this.added -= 1;
    //   let pattern: any = {id: this.added};
    //   if (this.contract) {
    //     pattern.contract = this.contract.code || this.contract;
    //   }
      
    //   let item = new LServer(pattern);
    //   this.data.splice(0, 0, item);
    //   this.dt.initRowEdit(item);
    }
  
    onRowEditInit(entity: any) {
        const pk = entity[this.settings.primaryKey || 'id'];
        this.cloned[pk] = entity;    // {...entity};
    }
  
    onRowEditSave(entity: any) {
        let validated = !this.isValid || this.isValid(entity);

        if (validated) {
            const pk = entity[this.settings.primaryKey || 'id'];
            delete this.cloned[pk];
  
            // if (entityid < 0) entity.id = null;
  
            this.onSave.emit(entity);
            // this.dataProvider.save(entity);
            // this.ui.messageService.add({severity:'success', summary: 'Success', detail:'Car is updated'});
        }
        else {
            this.ui.warning('Missing or invalid data');
            // this.messageService.add({severity:'error', summary: 'Error', detail:'Year is required'});
        }
    }
  
    onRowEditCancel(entity: any, index: number) {
        if (!this.changed) this.changed = [].concat(this.data);
  
        const pk = entity[this.settings.primaryKey || 'id'];
        this.changed[index] = this.cloned[pk];
        delete this.cloned[pk];
    }

    onRowDelete(entity: any, index: number) {
        this.onDelete.emit(entity);

        this.data.splice(index, 1);
    }
  
    exportPdf() {
        if (this.settings.can.exportPdf) {
          let columns = this.selectedColumns;
          if (!columns || columns.length == 0) {
            columns = this.cols;
          }          
          this.exporter.downloadPDF(this.data, columns, this.settings.title || 'Report');
        }
    }
  
    exportExcel() {
        if (this.settings.can.exportXls) {
          let columns = this.selectedColumns;
          if (!columns || columns.length == 0) {
            columns = this.cols;
          }          
          this.exporter.downloadExcel(this.data, columns, this.settings.title || 'Report');
        }
    }
}